import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-start py-2 px-4 items-center max-w-full flex-0" }
const _hoisted_2 = { class: "text-left font-semibold" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigSubsection',
  props: {
    subtitle: {
        type: String,
        required: false
    }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(props.subtitle ?? ''), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})